import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import qs from 'query-string';

import { useUser, useUserProfile } from '~/hooks';
import { useGetUserQuery } from '~/redux/slices/userSlice';
import * as constants from '~/constants';

import { LoaderWithOverlay } from '../molecules';
const ProtectedRoute = ({ children }) => {
  const user = useUser();
  const companyRepProfile = useUserProfile(constants.USER_PROFILE_TYPES.COMPANY_REP);
  const { isLoading: isLoadingUser } = useGetUserQuery();

  const { pathname, search, hash } = useLocation();
  let redirectPath = '/';
  let redirectParams = {
    next_path: encodeURI(pathname + search + hash),
  };

  // Show the loader overlay until user is fetched successfully once
  if (isLoadingUser) {
    return <LoaderWithOverlay visible />;
  } else {
    if (user) {
      if (!user.isEmailVerified) {
        // Force email verification
        redirectPath = '/auth';
      } else if (!companyRepProfile?.hasFinishedOnboarding && pathname !== '/account/onboarding') {
        // Force profile and company details addition
        redirectPath = '/account/onboarding';
      } else {
        // Render content
        return children ?? <Outlet />;
      }
    } else {
      // Force login
      redirectPath = '/auth';
    }
    return <Navigate to={redirectPath + '?' + qs.stringify(redirectParams)} replace />;
  }
};

export default ProtectedRoute;
